import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Rx'

import { OperationServiceAdapter } from '../operation'
import { JsonApiProcessor } from '../operation/operation-processors'
import { TestSegment, TestExecution } from '../../models'

@Injectable()
export class TestSegmentService extends OperationServiceAdapter<TestSegment> {

  public static DEFAULT_TEST_SEGMENT_INCLUDES = Object.freeze([
    'userAnswers.answerChoice',
    'question.questionType.displayType',
    'question.answerChoiceGroups.answerChoices',
    'question.answerChoiceGroups.labels',
    'question.explanations.explanationType',
    'question.questionContext.questionContextType',
    'question.questionPrompts',
    'question.majorTopic.category',
    'question.questionMetadatum',
    'screen',
    'testExecution.testExecutionRecord'
  ])

  constructor(
    _processor: JsonApiProcessor
  ) {
    super(_processor, TestSegment)
  }

  public getCurrent(execution: TestExecution): Observable<TestSegment> {
    return this.requestWithExecution(this.callGetOperation, 'current', execution)
  }
  public getPrevious(execution: TestExecution): Observable<TestSegment> {
    return this.requestWithExecution(this.callGetOperation, 'previous', execution)
  }
  public getFirst(execution: TestExecution): Observable<TestSegment> {
    return this.requestWithExecution(this.callGetOperation, 'first', execution)
  }
  public getNext(execution: TestExecution): Observable<TestSegment> {
    return this.requestWithExecution(this.callGetOperation, 'next', execution)
  }
  public getLast(execution: TestExecution): Observable<TestSegment> {
    return this.requestWithExecution(this.callGetOperation, 'last', execution)
  }
  public getIndex(execution: TestExecution, filter: {}, includes: string[] = []): Observable<TestSegment[]> {
    return this.requestWithExecution(this.callGetOperation, 'index', execution, {}, filter, includes)
  }

  public moveToCurrentOrFirst(execution: TestExecution): Observable<TestSegment> {
    // The 'current' POST operation, will return the current/last segment
    // However, if the user hasn't started (yet), it'll return the first element
    // So, this implies start or resume a test
    return this.requestWithExecution(this.callPostOperation, 'current', execution)
  }
  public moveToFirst(execution: TestExecution): Observable<TestSegment> {
    return this.requestWithExecution(this.callPostOperation, 'first', execution)
  }
  public moveToLast(execution: TestExecution): Observable<TestSegment> {
    return this.requestWithExecution(this.callPostOperation, 'last', execution)
  }
  public moveToPrevious(execution: TestExecution): Observable<TestSegment> {
    return this.requestWithExecution(this.callPostOperation, 'previous', execution)
  }
  public moveToNext(execution: TestExecution): Observable<TestSegment> {
    return this.requestWithExecution(this.callPostOperation, 'next', execution)
  }
  public moveTo(execution: TestExecution, args): Observable<TestSegment> {
    return this.requestWithExecution(this.callPostOperation, 'go_to', execution, { args: args })
  }

  public skip(execution: TestExecution, args: {}): Observable<TestSegment> {
    return this.requestWithExecution(this.callPostOperation, 'skip', execution, { args: args })
  }

  private requestWithExecution(operationFn, operationName, execution, extraParams = {}, filter = {}, includes = []) {
    return operationFn.call(
      this,
      operationName,
      { testExecution: execution, ...extraParams },
      includes.length > 0 ? includes : TestSegmentService.DEFAULT_TEST_SEGMENT_INCLUDES,
      { executionId: execution.id, ...filter }
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/test-segment/test-segment.service.ts